"use strict";

/**
* Кнопка.
* 
* @class WebAccess.components.wrappers.form.Button
* @extends WebAccess.components.wrappers.BasePageElement
* @property {string} name Имя ссылки
* @property {string} actionName имя дествия
* @property {string} selector Путь в DOM-иерархии к объекту группы, например div.content#container
* @param {string} itemSelector Cуществующий элемент страницы
*/
(function (global) {

  var Button = global.components.wrappers.BasePageElement.extend({

    init: function (itemSelector) {
      this._super(itemSelector);
      this.name = this._jObject.attr('button-name') || this._jObject.attr('id');
      this.actionName = this._jObject.data('action-name');
      this.selector = "#" + this.name; //TODO Будет неправильный селектор если указано button-name
    },

    className: "Button",
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~// 

    /**
    * Имитировать щелчок мыши.
    * Имитация щелчка мыши по ссылке либо установка обработчика на событие onClick, если передан callback. 
    * Заменяет обработчик по умолчанию.
    * 
    * @param {function} [opt_callback] Функция, которая будет вызвана после щелчка мыши по ссылке
    * @method  WebAccess.components.wrappers.form.Button#click    
    * @return {button}
    */
    click: function (opt_callback) {
      var me = this;
      me._super(opt_callback);
      if ($.isFunction(opt_callback)) {
        this._jObject.addClass('binded_button').removeClass('disabled');
      }
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Выхов нашего fire при клике на элемент
    * @private
    */
    _eventHandler: function (event) {
      var eventName = event.data.eventName;
      var name = event.data.actionName;
      var element = event.data.instance;
      var continueDefaultAction = event.data.continueDefaultAction;
      if (element.fire(eventName, name, continueDefaultAction) !== false && eventName === 'click') {
        element._defaultAction.call(element);
      };
    },

    /**
    * Подписка на события
    *          
    * @param {string} event
    * @method  WebAccess.components.wrappers.form.Button#bind
    * @return { WebAccess.components.wrappers.form.Button}
    */
    bind: function (event, callback) {
      var instance = this;
      this._super(event, callback);

      //if (event == "click") this._disableClickHandler(this._jObject);    
      this._jObject.unbind(event, this._eventHanler).bind(event, {
        "instance": instance,
        "eventName": event,
        "buttonName": instance.name,
        "actionName": instance._jObject.data('action-name'),
        "continueDefaultAction": $.proxy(instance._defaultAction, instance)
      }, this._eventHandler);

      this._jObject.addClass('binded_button').removeClass('disabled');
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//


    /**
    * Отключение ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Button#disable
    * @return { WebAccess.components.wrappers.form.Button}
    * @see module:tests/FormControls~isLinkRealyDisabled
    */
    disable: function () {
      if (this.isEnabled()) {
        this._super();
        this._jObject.removeClass("binded_button");
        this._jObject.attr("disabled", "disabled");
        return this;
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Включение ссылки, если она была отключена ранее.
    * 
    * @method  WebAccess.components.wrappers.form.Button#enable
    * @return { WebAccess.components.wrappers.form.Button}
    * @see module:tests/FormControls~isLinkRealyEnabled
    */
    enable: function () {
      if (!this.isEnabled()) {
        this._super();
        this._jObject.addClass("binded_button");
        this._jObject.removeAttr("disabled");
        return this;
      };
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Получить подпись ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Button#getLabel
    * @return {string}
    * @see module:tests/FormControls~getLabelValue
    */
    getLabel: function () {
      return this._jObject.val();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Установить подпись ссылки
    * 
    * @method  WebAccess.components.wrappers.form.Button#setLabel
    * @param {string} text текст подписи
    * @see module:tests/FormControls~setLabelValue
    * @return {link}
    */
    setLabel: function (text) {
      this._jObject.val(text);
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * @ignore
    * @method  WebAccess.components.wrappers.form.Button#setIcon
    */
    setIcon: function (path) {
      global.raise("ERR_UNSUPPORTED_METHOD");
      return this;
    },

    /**
    * @ignore
    * @method  WebAccess.components.wrappers.form.Button#getIcon
    */
    getIcon: function (path) {
      global.raise("ERR_UNSUPPORTED_METHOD");
      return this;
    }
  });

  global.components.wrappers.form.Button = Button;
})(window.WebAccess);